module.exports = __webpack_public_path__ + "img/a1-s40.2e9df27d.jpg";